import { getDayTimePeriod } from '@/lib/utils';
import { useMemo } from 'react';
import MorningSnapAndEarn from '@/assets/icons/snap_earn_morning.svg?react';
import AfternoonSnapAndEarn from '@/assets/icons/snap_earn_afternoon.svg?react';
import EveningSnapAndEarn from '@/assets/icons/snap_earn_evening.svg?react';

export function SnapAndEarn() {
  const timePeriod = useMemo(getDayTimePeriod, []);
  switch (timePeriod) {
    case 'morning':
      return <MorningSnapAndEarn />;
    case 'afternoon':
      return <AfternoonSnapAndEarn />;
    case 'evening':
      return <EveningSnapAndEarn />;
    default:
      return <MorningSnapAndEarn />;
  }
}
